export default __webpack_public_path__ + "static/media/f3.a290733d.svg";